import React, { Component } from 'react';
import { PLAYER1_COLOR, PLAYER2_COLOR } from '../const';

class Pie extends Component {
  render() {
    const { width, p1, p2 } = this.props;
    const px = `${width}px`;

    if (p1 === 100 || p2 === 100) {
      const color = p1 === 100 ? PLAYER1_COLOR : p2 === 100 ? PLAYER2_COLOR : null;
      return <div style={{ gridArea: '1/1', borderRadius: '50%', background: color, width: px, height: px }} />;
    }

    const radius = width / 2;
    const viewbox = `0 0 ${width} ${width}`;
    const transform = `translate(${radius}, ${radius})`;
    const paths = [];

    for (let i = 0; i < 2; i++) {
      const p = i === 0 ? p1 : p2;

      let angle = (p * 360) / 100;

      if (angle >= 180) {
        angle -= 180;
      }

      angle = 90 - angle;

      const rad = (angle * Math.PI) / 180;
      let x = radius * Math.cos(rad);
      let y = radius * Math.sin(rad);

      if (p > 50 === (i === 1)) {
        x = -x;
      }

      const largeArc = p > 50 ? 1 : 0;
      const sweep = i;

      y = Math.abs(y);

      if (p < 25 || p > 75) {
        y = -y;
      }

      const path = `M0,0 0,-${radius} A${radius},${radius} 0 ${largeArc} ${sweep} ${x},${y} Z`;
      paths.push(path);
    }

    return (
      <div style={{ gridArea: '1/1', width: px, height: px }}>
        <svg width={width} height={width} viewBox={viewbox}>
          <g transform={transform}>
            <path d={paths[0]} fill={PLAYER1_COLOR} />
            <path d={paths[1]} fill={PLAYER2_COLOR} />
          </g>
          xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
        </svg>
      </div>
    );
  }
}

export default Pie;
